module.exports = __webpack_public_path__ + "img/shareImg.ac76427e.jpg";